
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.521.783c.471 0 .514 1.455.514 1.455V6.73l3.85 1.925c.257.128.342.642.342.642v.171l-.213-.257h-.086L9.19 8.612l-1.198.043v1.583h.171v-.171c0-.086.086-.086.086-.086h.428c.128 0 .085.214.085.214v.984c0 .47-.171.77-.171.77h-.3l-.085-.3s-.128.044-.257.13c0 .384-.3 1.197-.3 1.197s1.028.385 1.284.47c.257.086.257.215.257.215l.043.427s-1.412-.213-1.626-.256c0 .128-.086.385-.086.385s-.085-.3-.085-.385c-.214.043-1.626.256-1.626.256l.043-.427s0-.086.257-.214c.256-.086 1.283-.47 1.283-.47s-.3-.857-.3-1.199l-.256-.128-.086.3h-.3s-.17-.3-.17-.77v-.985s-.043-.214.085-.214h.428s.086 0 .086.086v.171h.17V8.655l-1.283-.043-2.738.556h-.043l-.213.257v-.17s.085-.557.342-.643c.257-.085 3.85-1.925 3.85-1.925v-4.45S7.008.784 7.48.784h.042z"}})])
          )
        }
      }
    